import { MAP_TYPES } from '@deck.gl/carto';

const CUSTOMSQL_SOURCE_ID = 'customSqlSource';

const source = {
  id: CUSTOMSQL_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: undefined,
  data: undefined,
};

export default source;
